// Admin-only tools strip.
// Part of the Review page (components/Review.jsx). Split out 2026-10-14.

export default function AdminToolsCard({ appTotal, me, pending }) {
  return (
    <>
      {me && me.isAdmin && (
      <div className="card" style={{ padding: '0.6rem 1rem', marginBottom: '0.75rem', background: '#fafafa', display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '0.75rem', fontSize: '0.9em' }}>
        <strong style={{ color: '#0369a1' }}>DB status</strong>
        <span><strong>Approved:</strong> {appTotal.toLocaleString()}</span>
        <span>·</span>
        <span><strong>Sheet inbox:</strong> {pending.counts.total.toLocaleString()} ({pending.counts.matched.toLocaleString()} matched · {pending.counts.pending.toLocaleString()} pending)</span>
      </div>
      )}
    </>
  );
}
